import template   from './rlink-apps-status.html'
import controller from './rlink-apps-status.controller'
import './rlink-apps-status.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/rlink-apps-status/rlink-apps-status.component.js